import React from 'react';
import styles from './Table.module.css';

export interface TableProps {
  children: React.ReactNode;
  className?: string;
}

const Table: React.FC<TableProps> = ({ 
  children, 
  className = ''
}) => {
  return (
    <div className={`${styles.table} ${className}`}>
      <div className={styles.tableScrollWrapper}>
        <div className={styles.tableContent}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Table;

